<template>
  <div id="app">
    <div :class="{ bg_flat: isLogin }">
      <Menu></Menu>
      <router-view />
      <Rodape></Rodape>
    </div>
  </div>
</template>

<script>
import Menu from "./components/Menu.vue";
import Rodape from "./components/Rodape.vue";

export default {
  name: "App",
  components: {
    Menu,
    Rodape,
  },
  computed: {
    isLogin() {
      console.log(this.$route.path)
      return this.$route.path === '/login';
    }
  }
};
</script>

<style>
body {
  font-family: "Barlow", sans-serif !important;
  overflow-x: hidden;
}

@media (max-width: 767px) {
  body {
    background-color: #396477 !important;
  }
}

@media (min-width: 768px) {
  body {
    background-image: url("/img/bg.png");
    background-position: top left;
    background-size: cover;
  }
}
</style>
